new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');
            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                var inputElement = document.getElementById("valorParaCopiar");
                if (inputElement) {
                    var newValueInput = inputElement.value.replace(/^\/\//, '');
                    inputElement.value = newValueInput

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            inputElement.select();

                            document.execCommand("copy");

                            window.getSelection().removeAllRanges();

                            alert("Valor copiado: " + newValueInput);
                        });
                    }
                }
            }
        });
    }
});

//sliders
$(document).ready(function () {
    
    waitForElementToExist('.band-communique__content').then(element => {
        $('#comunicados-slider').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 1500,
            dots: false,
            infinite: true,
            mobileFirst: true,
            adaptiveHeight: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            slidesToShow: 1,
            responsive: [
                {
                 breakpoint: 992,
                 settings: "unslick"
               },
           ]
        });
    });

    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.first-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list');
        if(vitrineCarrousel) {
            $('#product_list').slick({
                adaptiveHeight: true,
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list2');
        if(vitrineCarrousel) {
            $('#product_list2').slick({
                adaptiveHeight: true,
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                ]
            });

            $('#product_list2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list3');
        if(vitrineCarrousel) {
            $('#product_list3').slick({
                adaptiveHeight: true,
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                        }
                    },
                ]
            });

            $('#product_list3').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.buy-category').then(element => {
        $('.buy-category-content').slick({
            adaptiveHeight: true,
            arrows: true,
            swipeToSlide: true, 
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 100,
            responsive: [
                {
                    breakpoint: 992,
                    settings: 'unslick'
                },
            ]
        });
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        $('.faixa-comunicado-content').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            autoplay: true,
            autoplaySpeed: 1500,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 992,
                    settings: 'unslick'
                },
            ]
        });
    });

    waitForElementToExist('.product-ratings-list').then(element => {
        $('.product-ratings-list').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 400,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.product-detail-faq').then(element => {
        const productDetailFaqListItems = document.querySelectorAll('.product-detail-faq-list-item');

        if (productDetailFaqListItems.length) {
            productDetailFaqListItems[0].classList.add('active');

            function activeTab(index) {
                productDetailFaqListItems.forEach((content) => {
                    content.classList.remove('active');
                });
                productDetailFaqListItems[index].classList.add('active');
            }

            productDetailFaqListItems.forEach((itemMenu, index) => {
                itemMenu.addEventListener('click', () => {
                    activeTab(index);
                });
            });
        }
    });

});